export const UPDATE_ERROR = "error/UPDATE_ERROR";
export const RESET_ERROR = "error/RESET_ERROR";
